import { render, staticRenderFns } from "./ApplyInfo.vue?vue&type=template&id=2bc5e1a0&scoped=true&"
import script from "./ApplyInfo.vue?vue&type=script&lang=js&"
export * from "./ApplyInfo.vue?vue&type=script&lang=js&"
import style0 from "./ApplyInfo.vue?vue&type=style&index=0&id=2bc5e1a0&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc5e1a0",
  null
  
)

export default component.exports